// extracted by mini-css-extract-plugin
export default {"label":"textarea_label__kyI1r","contentLength":"textarea_contentLength__nTXYH","textarea":"textarea_textarea__Gvawd","disabled":"textarea_disabled__F8lXM"};